export const toastStyles = {
  autoClose: 3000,
  hideProgressBar: false,

  pauseOnHover: true,
  draggable: true,

  style: {
    backgroundColor: '#c754ebb4 ',
    color: 'white',
    fontSize: '16px',
    padding: '10px',
    fontFamily: 'Poppins, sans-serif',
    borderRadius: '8px',
  },
  theme: 'colored',
};

export const toastContainerStyles = {
  position: 'top-right',
  padding: '10px',
  color: 'white',
  fontFamily: 'Poppins, sans-serif',
  borderRadius: '8px',
};

export const deleteToastStyles = {
  closeOnClick: false,
  width: '350px',
  autoClose: 3000,
  hideProgressBar: false,
  closeButton: false,
  pauseOnHover: true,
  draggable: true,

  style: {
    backgroundColor: '#c754ebb4 ',
    color: 'white',
    fontSize: '16px',
    padding: '16px',
    fontFamily: 'Poppins, sans-serif',
    borderRadius: '8px',
  },
  theme: 'colored',
};
